(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-collections-niveau-0"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initialize(root) {
      root.querySelectorAll('.oc-collections-level-0__carousel').forEach((carousel) => {
        if (initialized.has(carousel)) return;
        initialized.add(carousel);

        const track = carousel.querySelector('.oc-collection-menu--scroll');
        const previous = carousel.querySelector('.oc-collections-level-0__arrow--previous');
        const next = carousel.querySelector('.oc-collections-level-0__arrow--next');
        const toggle = carousel.parentElement.querySelector('.oc-collections-level-0__motion-toggle');
        if (!track || !previous || !next || !toggle) return;

        const controller = new AbortController();
        let frameId = 0;
        let lastFrame = 0;
        let animatedPosition = 0;
        let resumeTimer = 0;
        let pauseUntil = 0;
        let direction = 1;
        let visible = false;
        let hovered = false;
        let focused = false;
        let pointerFocused = false;
        let manuallyPaused = false;

        const scrollLimit = () => Math.max(0, track.scrollWidth - track.clientWidth);

        function updateControls() {
          const limit = scrollLimit();
          previous.disabled = limit <= 1 || track.scrollLeft <= 2;
          next.disabled = limit <= 1 || track.scrollLeft >= limit - 2;
          toggle.hidden = limit <= 1 || reducedMotion.matches;
        }

        function stop() {
          if (frameId) window.cancelAnimationFrame(frameId);
          frameId = 0;
          lastFrame = 0;
        }

        function canPlay() {
          return visible && !hovered && !focused && !manuallyPaused &&
            !reducedMotion.matches && !document.hidden && scrollLimit() > 1;
        }

        function frame(time) {
          frameId = 0;
          if (!canPlay()) { lastFrame = 0; return; }

          const elapsed = lastFrame ? Math.min(time - lastFrame, 64) : 0;
          lastFrame = time;
          const limit = scrollLimit();
          animatedPosition += direction * 22 * elapsed / 1000;

          if (animatedPosition >= limit) {
            animatedPosition = limit;
            track.scrollLeft = limit;
            direction = -1;
          } else if (animatedPosition <= 0) {
            animatedPosition = 0;
            track.scrollLeft = 0;
            direction = 1;
          } else {
            track.scrollLeft = animatedPosition;
          }
          frameId = window.requestAnimationFrame(frame);
        }

        function start() {
          if (frameId || !canPlay()) return;
          const delay = pauseUntil - performance.now();
          if (delay > 0) {
            window.clearTimeout(resumeTimer);
            resumeTimer = window.setTimeout(start, delay + 25);
            return;
          }
          window.clearTimeout(resumeTimer);
          lastFrame = 0;
          animatedPosition = track.scrollLeft;
          frameId = window.requestAnimationFrame(frame);
        }

        function pauseFor(milliseconds) {
          pauseUntil = performance.now() + milliseconds;
          stop();
          start();
        }

        function moveBy(amount) {
          direction = Math.sign(amount);
          pauseFor(8000);
          track.scrollBy({ left: amount * Math.max(track.clientWidth * .72, 220), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }

        previous.addEventListener('click', () => moveBy(-1), { signal: controller.signal });
        next.addEventListener('click', () => moveBy(1), { signal: controller.signal });
        toggle.addEventListener('click', () => {
          manuallyPaused = !manuallyPaused;
          toggle.setAttribute('aria-pressed', String(manuallyPaused));
          toggle.querySelector('span').textContent = manuallyPaused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel;
          if (manuallyPaused) stop();
          else { pauseUntil = 0; start(); }
        }, { signal: controller.signal });

        carousel.addEventListener('mouseenter', () => { hovered = true; stop(); }, { signal: controller.signal });
        carousel.addEventListener('mouseleave', () => {
          hovered = false;
          if (pointerFocused) { focused = false; pointerFocused = false; }
          start();
        }, { signal: controller.signal });
        carousel.addEventListener('pointerdown', () => {
          pointerFocused = true;
          pauseFor(8000);
        }, { signal: controller.signal });
        carousel.addEventListener('focusin', () => {
          if (!pointerFocused) { focused = true; stop(); }
        }, { signal: controller.signal });
        carousel.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!carousel.contains(document.activeElement)) {
              focused = false;
              pointerFocused = false;
              start();
            }
          }, 0);
        }, { signal: controller.signal });
        track.addEventListener('wheel', () => pauseFor(8000), { passive: true, signal: controller.signal });
        track.addEventListener('scroll', updateControls, { passive: true, signal: controller.signal });
        window.addEventListener('resize', updateControls, { signal: controller.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stop(); else start();
        }, { signal: controller.signal });
        reducedMotion.addEventListener('change', () => {
          updateControls();
          if (reducedMotion.matches) stop(); else start();
        }, { signal: controller.signal });

        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        }, { threshold: .1 });
        observer.observe(carousel);

        const resizeObserver = new ResizeObserver(() => { updateControls(); start(); });
        resizeObserver.observe(track);

        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(carousel)) return;
          observer.disconnect();
          resizeObserver.disconnect();
          controller.abort();
          window.clearTimeout(resumeTimer);
          stop();
        }, { signal: controller.signal });

        updateControls();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-home-ambient"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const home = document.querySelector('body.oc-homepage');
    const guide = document.querySelector('.oc-home-guide');
    if (!home || !guide || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver(([entry]) => {
      home.dataset.ocAmbient = entry.isIntersecting ? 'guide' : 'pink';
    }, { rootMargin: '-15% 0px -15% 0px', threshold: 0 });
    observer.observe(guide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc_faq_hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const initialize = (root) => {
      if (!root || root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      const input = root.querySelector('[data-faq-search]');
      if (!input) return;

      const items = Array.from(root.querySelectorAll('[data-faq-item]'));
      const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
      const links = Array.from(root.querySelectorAll('[data-category-link]'));
      const noResults = root.querySelector('[data-faq-no-results]');

      const filterItems = () => {
        const query = normalize(input.value);
        let visibleCount = 0;

        items.forEach((item) => {
          const haystack = normalize(`${item.textContent} ${item.dataset.searchTerms || ''}`);
          const visible = query === '' || haystack.includes(query);
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        groups.forEach((group) => {
          const hasVisibleItem = Array.from(group.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
          group.hidden = !hasVisibleItem;
        });

        links.forEach((link) => {
          const group = root.querySelector(`[data-faq-group="${link.dataset.categoryLink}"]`);
          link.hidden = Boolean(group && group.hidden);
        });

        if (noResults) noResults.hidden = visibleCount !== 0;
      };

      input.addEventListener('input', () => {
        if (document.startViewTransition) {
          document.startViewTransition(filterItems);
        } else {
          filterItems();
        }
      });
    };

    document.querySelectorAll('[data-oc-faq]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-oc-faq]')
        ? event.target
        : event.target.querySelector('[data-oc-faq]');
      initialize(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
